import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  profile: null,
  owner: null,
  hasChat: false,
  currentSessionID: null,
}

const slice = createSlice({
  name: 'selectedPatient',
  initialState: initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload
    },
    setOwner: (state, action) => {
      state.owner = action.payload
    },

    setCurrentSession: (state, action) => {
      state.currentSessionID = action.payload
      state.hasChat = true
    },

    // remove current session
    removeCurrentSession: (state) => {
      state.currentSessionID = null
      state.hasChat = false

      return state
    },
  },
})

export const {
  setOwner,
  setProfile,
  setCurrentSession,
  removeCurrentSession,
  removeProfile,
} = slice.actions
export default slice.reducer
